import {connect} from "react-redux";
import ValetOpportunities from "./create";
import {bindActionCreators} from "redux";
import {dropdownData} from "../../../service/Account/action";
import {save} from "../../../service/Opportunities/action";
// import {save, opportunityQuestion, getOpportunity} from "../../service/Opportunities/action";
// import {documentUploadUrlPublic} from "../../service/fileUpload/action";
import {accountById} from "../../../service/Valet/action";

const mapStateToProps = (state) => ({
    dropdownValue:state.Dropdown.dropdownValue,
    saveDetails:state.Opportunitie.saveDetails,
    // opportunityQuestionDetails:state.Opportunitie.opportunityQuestion,
    // opportunityDetails:state.Opportunitie.opportunityDetails,
    // documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    // accountDetails:state.Dropdown.accountDetailsById,
    accountDetailsByIdData:state.Valet.accountById,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            dropdownData,
            save,
            // opportunityQuestion,
            // getOpportunity,
            // documentUploadUrlPublic,
            accountById
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ValetOpportunities);
